import { takeLatest, call, put, select } from 'redux-saga/effects';

import { type OpDefData } from '@frontend/api';

import opDefService from 'services/opDefService';

import { getGroupId } from 'store/session/selectors';

import { fetchOpDefs, ACTION_TYPES } from './actions';

export default function* root() {
  yield takeLatest(ACTION_TYPES.FETCH_OP_DEFS_REQUEST, watchFetchOpDefs);
}

function* watchFetchOpDefs() {
  try {
    const groupId: string = yield select(getGroupId);
    const response: OpDefData[] = yield call(opDefService.listOpDefs, groupId);
    yield put(fetchOpDefs.success({ opDefs: response }));
  } catch (error) {
    yield put(fetchOpDefs.error(error as Error));
  }
}
